<template>
  <div
    class="base-template"
    :class="{'hide-base-bg-image': !isShowBaseContents, 'is_top': isTop, gacha_animation: isGachaAnimation}"
  >
    <CommonHeader
      v-if="isShowBaseContents"
      :availablePoint="availablePoint"
      :currentUser="currentUser"
      :isTop="isTop"
      :banner="banner"
      @handleShopNameClick="goToTop"
      @handlePointBoxClick="goToBuyPoint"
    />
    <div class="contents" :class="{adjust: currentUser, gacha_animation: isGachaAnimation, isHide: isHide}">
      <slot></slot>
    </div>
    <CommonFooter
      class="common-footer"
      v-if="isShowBaseContents && !isHide"
      :currentUser="currentUser"
      :isLineup="isLineup"
    />
    <FooterMenu v-if="!isGachaAnimation && !isHide" />
    <SnackBar
      :isVisible="snackbar.isVisible"
      :message="snackbar.message"
      :type="snackbar.type"
      @close="hideSnackbar"
    />
    <CommonOverlay class="overlay" v-show="isLoading">
      <v-progress-circular indeterminate color="red"></v-progress-circular>
    </CommonOverlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { separateCharacterNumber } from '@/common/util/format';

import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonHeader from '@/components/organisms/CommonHeader.vue';
import CommonFooter from '@/components/organisms/CommonFooter.vue';
import FooterMenu from '@/components/organisms/FooterMenu.vue';
import SnackBar from '@/components/atoms/SnackBar.vue';

export default {
  name: 'BaseTempalte',

  components: {
    CommonOverlay,
    CommonHeader,
    CommonFooter,
    FooterMenu,
    SnackBar,
  },

  props: {
    isShowBaseContents: {
      type: Boolean,
      default: true,
    },
    isTop: {
      type: Boolean,
      default: false,
    },
    isLineup: {
      type: Boolean,
      default: false,
    },
    isHide: {
      type: Boolean,
      default: false,
    },
    banner: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      isLoading: 'isLoading',
      fullPath: 'fullPath',
      snackbar: 'market/snackbar',
    }),
    availablePoint() {
      if (this.currentUser) {
        return separateCharacterNumber(this.currentUser.point);
      }
      return '0';
    },
    isGachaAnimation() {
      if (this.fullPath === '/gacha-animation') {
        return true;
      }
      return false;
    },
  },

  methods: {
    goToTop() {
      if (this.$route.name === 'Top') {
        return;
      }
      this.$router.push('/');
    },
    goToBuyPoint() {
      if (this.$route.name === 'BuyPoint') {
        return;
      }
      if (this.currentUser.is_login === '0') {
        if (this.$route.name === 'UserLogin') {
          return;
        }
        this.goToLogin();
        return;
      }
      let url = '/buy-point';
      if (this.$route.params.productId) {
        url += `/${this.$route.params.productId}`;
      }
      this.$router.push(url);
    },
    hideSnackbar() {
      this.$store.dispatch('market/hideSnackbar');
    },
  },
};
</script>

<style lang="scss" scoped>
$headerHeight: 70px;
$footerHeight: 80px;

.base-template{
  height: calc(100% - 100px);
  padding: 0 10px;
  &.hide-base-bg-image{
    height: calc(100% - 100px);
    background: $black;
    .contents{
      &.adjust{
        height: calc(100% - 100px);
      }
      &.gacha_animation {
        height: 100vh;
      }
    }
  }
  &.gacha_animation {
    height: 100vh;
  }
  .contents{
    width: 100%;
    min-height: calc(100vh - 303px);
    padding-bottom: 275px;
    // height: 100vh;
    &.adjust{
      padding-top: 20px;
      padding-bottom: 325px;
    }
    &.gacha_animation {
      min-height: 100vh;
    }
    &.isHide{
      height: 100vh;
    }
  }
  .overlay{
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.is_top {
  height: auto;
  .contents{
    width: 100%;
    height: auto;
    // zoom: 0.75;
    @media screen and  (max-width: $tabletWidth) {
      zoom: 1;
    }
    &.adjust{
      padding-top: 0;
      height: calc(100% - 800px);
      min-height: 60vh;
      //padding-bottom: 80px;
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .base-template{
    .contents{
      padding-bottom: 375px;
      &.adjust{
        height: auto;
        padding-top: 0px;
        padding-bottom: 375px;
      }
    }
  }
}
</style>
